import { render } from "./DataCard.vue?vue&type=template&id=6797e3a9&scoped=true"
import script from "./DataCard.vue?vue&type=script&lang=js"
export * from "./DataCard.vue?vue&type=script&lang=js"

import "./DataCard.vue?vue&type=style&index=0&id=6797e3a9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6797e3a9"]])

export default __exports__